import { css } from "styled-components";
import token from "styled-token";
import { StyledHelpCircle, StyledHelpQuestion } from "../../components/Icon/icons/IconHelp";
import { hoverMediaQueryMixin } from "../hoverMediaQueryMixin";
/** @class TriggerButtonMixin */

/** @method */

export var TriggerButtonMixin = token({
  borderRadius: "radii.ellipse",
  boxShadow: "shadows.focus",
  size: "icons.sizes.xs",
  helpCircleFill: "TriggerButton.helpCircleFillColor",
  helpCircleFillActive: "TriggerButton.helpCircleFillColorActive",
  helpCircleFillHover: "TriggerButton.helpCircleFillColorHover",
  helpCircleStroke: "TriggerButton.helpCircleStrokeColor",
  helpCircleStrokeHover: "TriggerButton.helpCircleStrokeColorHover",
  helpCircleStrokeActive: "TriggerButton.helpCircleStrokeColorActive",
  helpQuestionFill: "TriggerButton.helpQuestionFillColor",
  helpQuestionFillActive: "TriggerButton.helpQuestionFillColorActive"
}, function (tokens) {
  return css(["background:transparent;display:inline-block;vertical-align:top;border:0;padding:0;border-radius:", ";height:", "px;width:", "px;", "{fill:", ";stroke:", ";}", "{fill:", ";}", ";&:active{", "{stroke:", ";fill:", ";}", "{fill:", ";}}&:focus{outline:none;box-shadow:", ";}position:relative;&:after{content:\"\";cursor:pointer;position:absolute;top:-5px;right:-5px;bottom:-5px;left:-5px;}"], tokens.borderRadius, tokens.size, tokens.size, StyledHelpCircle, tokens.helpCircleFill, tokens.helpCircleStroke, StyledHelpQuestion, tokens.helpQuestionFill, hoverMediaQueryMixin("\n            " + StyledHelpCircle + " {\n                stroke: " + tokens.helpCircleStrokeHover + ";\n                fill: " + tokens.helpCircleFillHover + ";\n            }\n        "), StyledHelpCircle, tokens.helpCircleStrokeActive, tokens.helpCircleFillActive, StyledHelpQuestion, tokens.helpQuestionFillActive, tokens.boxShadow);
});